exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_normalize.css"), "");

// module
exports.push([module.id, "._2Wa9wu-awiDVZ9IXTPcyFt {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n\n._38MtHDcUga2pYTxIRJJZ8o {\n    max-width: 800px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "_2Wa9wu-awiDVZ9IXTPcyFt",
	"container": "_38MtHDcUga2pYTxIRJJZ8o"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/SchemaDocsView.css
 ** module id = 28
 ** module chunks = 0
 **/